export default __webpack_public_path__ + "static/media/proflight-zambia-logo.b5e776bd.png";